const FORM_ASSIGNMENT_TYPE = {
    none: 0,
    students: 1,
    employees: 2,
};

export default FORM_ASSIGNMENT_TYPE;